<template>
    <div id="privacy">
        <Menu/>
        <b-container id="privacy-wrapper">
            <b-row>
                <b-col>
                    <h1 class="mb-5">{{ $t('contact.privacy') }}</h1>
                    <div v-html="$t('privacy.text')">
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import Menu from '../components/Menu.vue'
    export default {
        name: 'Privacy',
        components: {
            Menu,
        }
    }
</script>

<style scoped>
#privacy-wrapper{
    padding-top: 170px; 
    padding-bottom: 100px; 
}
h1{
    font-weight: 400;
    font-size: 35px;
}

</style>